import React from 'react';

import PropTypes from 'prop-types';

import SplitTestContext from './SplitTestContext';

function Control({ aliases, children }) {
    return (
        <SplitTestContext.Consumer>
            {({ experimentGroup }) => (
                experimentGroup === 'control' || aliases.includes(experimentGroup)
                    ? children
                    : null
            )}
        </SplitTestContext.Consumer>
    );
}

Control.propTypes = {
    aliases: PropTypes.arrayOf(PropTypes.string),
};

Control.defaultProps = {
    aliases: [],
};

export default Control;
